import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PhotoFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="photoFilled" ref={ref} {...props}>
      <path d="M19.09,2.22H4.92A2.75,2.75,0,0,0,2.17,5V19.14a2.75,2.75,0,0,0,2.75,2.75H19.09a2.75,2.75,0,0,0,2.75-2.75V5A2.75,2.75,0,0,0,19.09,2.22ZM8.79,13.3c.65-.58,1.07-.35,1.6,0a1.32,1.32,0,0,0,1.65,0c.58-.44,2.06-1.79,2.65-2.19a1.33,1.33,0,0,1,1.77.12,18.47,18.47,0,0,1,1.87,2v4.64c0,.37-.2.35-.83.35H6.18c-.51,0-.51-.28-.51-.57V16.22S8.13,13.88,8.79,13.3ZM7.59,9.06a1.4,1.4,0,1,1,2.79,0,1.4,1.4,0,0,1-2.79,0Z" />
    </Icon>
  ),
) as IconWithRender;

PhotoFilledIcon.displayName = 'PhotoFilledIcon';
PhotoFilledIcon.renderIcon = (props) => <PhotoFilledIcon {...props} />;
export default PhotoFilledIcon;
